import type { MapboxIMap } from '..';

export const disableMovement: MapboxIMap['disableMovement'] = function (
  this: MapboxIMap
) {
  this._native.dragPan.disable();
  this._native.scrollZoom.disable();
};
